import axios from "../library/axiosConfig";

export default {

  getDownlod (headers) {
    return axios.post('/broker/appversion/getDownlod', {}, {baseURL: axios.defaults.brokerAPP, headers: headers})
  },
  sendEntryVerifyCode (data) {
    return axios.post('/broker/sendEntryVerifyCode', data, {baseURL: axios.defaults.brokerAPP})
  },
  h5Register (data) {
    return axios.post('/broker/h5RegisterNew',data, {baseURL: axios.defaults.brokerAPP})
  },
  getBrokerCityList (data = {}) {
    return axios.post('/broker/community/findCityListIncludeDistrict',data, {baseURL: axios.defaults.brokerAPP})
  }
}



// WEBPACK FOOTER //
// ./src/api/brokerApp.js